import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21 10.5C21 9.55573 20.5554 8.66656 19.8 8.1L13.8 3.6C12.7333 2.8 11.2667 2.8 10.2 3.6L4.2 8.1C3.44458 8.66656 3 9.55573 3 10.5V17.7753C3 19.306 4.15239 20.5913 5.67402 20.7576L8.08701 21.0213C8.97467 21.1184 9.75 20.4232 9.75 19.5302V17.4594C9.75 15.7408 10.875 15 12 15C13.125 15 14.25 15.7408 14.25 17.4594V19.5302C14.25 20.4232 15.0253 21.1184 15.913 21.0213L18.326 20.7576C19.8476 20.5913 21 19.306 21 17.7753V10.5Z"
      stroke="#262626"
      stroke-width="2"
    />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.9 3.2C11.1444 2.26667 12.8556 2.26667 14.1 3.2L20.1 7.7C20.9813 8.36099 21.5 9.39835 21.5 10.5V17.7753C21.5 19.5611 20.1555 21.0606 18.3803 21.2546L15.9673 21.5184C14.7838 21.6477 13.75 20.7208 13.75 19.5302V17.4594C13.75 16.7153 13.5102 16.2395 13.2028 15.948C12.8885 15.65 12.4562 15.5 12 15.5C11.5438 15.5 11.1115 15.65 10.7972 15.948C10.4898 16.2395 10.25 16.7153 10.25 17.4594V19.5302C10.25 20.7208 9.21623 21.6477 8.03268 21.5184L5.61969 21.2546C3.84446 21.0606 2.5 19.5611 2.5 17.7753V10.5C2.5 9.39835 3.01868 8.36099 3.9 7.7L9.9 3.2Z"
      fill="url(#paint0_linear_18903_5695)"
    />
    <defs>
      <linearGradient id="paint0_linear_18903_5695" x1="5.5" y1="4" x2="21" y2="20" gradientUnits="userSpaceOnUse">
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconHome() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
